// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import GuidEventLookupSchema from './guid-event-lookup-schema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/guid-event-lookup-list-result-schema',
  type: 'object',
  required: [],
  properties: {
    items: {
      type: 'array',
      nullable: true,
      items: { ...GuidEventLookupSchema },
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
  },
} as IJSONSchema;

export default schema;
